// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { SalesSubscriptions } from '../../../../types/server/modules/sales/subscriptions';

export type * from '../../../../types/server/modules/sales/subscriptions';

export const createSubscriptions = ( requests: Requests ): SalesSubscriptions => ({
  SalesAccountConfiguration: ( params, onChange ) => {
          return requests.subscribe( `/sales/account-configuration/:id?`, params, 'SalesAccountConfiguration', onChange );
          },
  SalesOrders: ( params, onChange ) => {
          return requests.subscribe( `/sales/orders/:id?`, params, 'SalesOrders', onChange );
          },
  SalesCustomers: ( params, onChange ) => {
          return requests.subscribe( `/sales/customers/:id?`, params, 'SalesCustomers', onChange );
          },
  CrmQuestions: ( params, onChange ) => {
          return requests.subscribe( `/crm/questions/:id?`, params, 'CrmQuestions', onChange );
          },
  SalesMessagingMessages: ( params, onChange ) => {
          return requests.subscribe( `/sales/messaging/messages/:id?`, params, 'SalesMessagingMessages', onChange );
          },
  SalesMessagingOutboundMessages: ( params, onChange ) => {
          return requests.subscribe( `/sales/messaging/outbound-messages/:id?`, params, 'SalesMessagingOutboundMessages', onChange );
          }
});
